import { EditCampaign } from './EditCampaign';
import withCampaign from './withCampaignData';
import withUpdateCampaign from './withUpdateCampaign';


//@ts-ignore
export default withCampaign(withUpdateCampaign(EditCampaign));
